import "leaflet/dist/leaflet.css";
import './Map.css'
import { useState, useEffect } from 'react'
import { icon, LatLngBounds } from 'leaflet'
import { MapContainer, TileLayer, LayersControl, LayerGroup, Marker, Tooltip, Popup, Circle, ImageOverlay } from "react-leaflet"
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import doRequest from '../requests/requests'
import Actions from '../actions/Actions'
import Sidebar from "./dam/DamSidebar";
import EarthquakeDetails from './EarthquakeDetails';
import hazardMapDetailed from "../img/mapa-labels-final.png";
import hazardMap from "../img/mapa-cores-final.png";


function Map() {
    let uri = "https://sshm4damsapi.fly.dev"
    const [dams, setDams] = useState()
    const [epicenters, setEpicenters] = useState()
    const [selected, setSelected] = useState()
    const [dayEarthquakes, setDayEarthquakes] = useState();
    const [monthEarthquakes, setMonthEarthquakes] = useState();
    const [updateMessage, setUpdateMessage] = useState('');

    const epicenterIcon = new icon({
        iconUrl: require('../resources/earthquake.png'),
        iconSize: [20, 20]
    })

    async function fetch(uri, errMsg) {
        try {
            const respDams = await doRequest({ onProgress: undefined, uri: uri, method: "GET" })
            if (respDams.ok) {
                return await respDams.json()

            } else {
                alert(errMsg)
                console.error(await respDams.json())
            }
        } catch (error) {
            alert(errMsg)
            console.error(error)
        }
    }

    useEffect(() => {
        async function fetchData() {
            await fetchDams();
            await fetchEpicenters();
            await fetchEarthquakes();
        }
        fetchData();

        const intervalId = setInterval(() => {
            fetchEarthquakes();
        }, 5 * 60 * 1000);

        // Clean up the interval when the component unmounts
        return () => {
            clearInterval(intervalId);
        };
    }, []);

    function fetchEpicenters() {
        fetch(uri + "/epicenters", "Get epicenters error")
            .then(resp => setEpicenters(resp));
    }

    function fetchDams() {
        fetch(uri + "/dams", "Get dams error")
            .then(resp => setDams(resp));
    }

    function fetchEarthquakes() {
        fetch(uri + "/earthquakes/lastdaymin2.5", "Get earthquakes error")
            .then(resp => setDayEarthquakes(resp));

        fetch(uri + "/earthquakes/lastmonthmin4", "Get earthquakes error")
            .then(resp => setMonthEarthquakes(resp));

        setUpdateMessage(`Data last updated at ${new Date().toLocaleString('pt-PT')}`);
    }

    const mapBounds = new LatLngBounds([-90, -180], [90, 180])
    const bounds = new LatLngBounds([83.5, 180], [-59.7, -180.3])


    return (
        <>
            <MapContainer
                className='map'
                center={[38, -9]}
                zoom={7}
                minZoom={2}
                maxZoom={15}
                scrollWheelZoom={true}
                maxBounds={mapBounds}
                maxBoundsViscosity={1.0}
            >
                <TileLayer
                    noWrap={true}
                    url="http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                    subdomains={['mt1', 'mt2', 'mt3']}
                    attribution='&copy; <a href="https://developers.google.com/maps/terms-20180207">Google</a> contributors'
                />
                <LayersControl position="topright">
                    <LayersControl.Overlay name='Dams' checked={true}>
                        <LayerGroup>
                            {
                                dams?.entities?.map(dam =>
                                    <DamCard dam={dam} onExpand={(link) => setSelected(link)} />)
                            }
                        </LayerGroup>
                    </LayersControl.Overlay >
                    <LayersControl.Overlay name='Historical Epicenters'>
                        <LayerGroup>
                            {
                                epicenters?.entities?.map(epicenter =>
                                    <Epicenter
                                        epicenter={epicenter}
                                        onSelect={(link) => setSelected(link)} />)
                            }
                        </LayerGroup>
                    </LayersControl.Overlay >

                    <LayersControl.Overlay name='Seismic Hazard' /* checked={true} */>
                        <LayerGroup>
                            <ImageOverlay
                                url={hazardMap}
                                bounds={bounds}
                                opacity={1}
                                zIndex={11}
                            />
                        </LayerGroup>
                    </LayersControl.Overlay >

                    <LayersControl.Overlay name='Detailed Seismic Hazard' /* checked={true} */>
                        <LayerGroup>
                            <ImageOverlay
                                url={hazardMapDetailed}
                                /* url="https://imagizer.imageshack.com/v2/1081x572q70/922/EHIoxR.png" */
                                bounds={bounds}
                                opacity={1}
                                zIndex={11}
                            />
                        </LayerGroup>
                    </LayersControl.Overlay >

                    {dayEarthquakes && (
                        <LayersControl.Overlay name='USGS Magnitude 2.5+ Earthquakes, Last 24h ' /* checked={true} */>
                            <div className="update-msg">{updateMessage}</div>
                            <LayerGroup>
                                {dayEarthquakes && dayEarthquakes.map(earthquake => (
                                    <Marker
                                        key={earthquake.id}
                                        position={[earthquake.geometry.coordinates[1], earthquake.geometry.coordinates[0]]}
                                        icon={epicenterIcon}
                                    >
                                        <Tooltip
                                            direction="bottom"
                                            offset={[0, 10]}
                                            opacity={1}
                                        >
                                            {earthquake.properties.place}
                                        </Tooltip>

                                        <Popup>
                                            <EarthquakeDetails earthquake={earthquake} />
                                        </Popup>
                                    </Marker>
                                ))}
                            </LayerGroup>
                        </LayersControl.Overlay >)}

                    {monthEarthquakes && (
                        <LayersControl.Overlay name='USGS Magnitude 4+ Earthquakes, Past Month ' /* checked={true} */>
                            <LayerGroup>
                                {monthEarthquakes && monthEarthquakes.map(earthquake => (
                                    <Marker
                                        key={earthquake.id}
                                        position={[earthquake.geometry.coordinates[1], earthquake.geometry.coordinates[0]]}
                                        icon={epicenterIcon}
                                    >
                                        <Tooltip
                                            direction="bottom"
                                            offset={[0, 10]}
                                            opacity={1}
                                        >
                                            {earthquake.properties.place}
                                        </Tooltip>

                                        <Popup>
                                            <EarthquakeDetails earthquake={earthquake} />
                                        </Popup>
                                    </Marker>
                                ))}
                            </LayerGroup>
                        </LayersControl.Overlay >)}


                    <div className="actions">
                        {dams?.actions !== undefined &&
                            <Actions actions={dams.actions} onSuccess={fetchDams} />}
                        {epicenters?.actions !== undefined &&
                            <Actions actions={epicenters.actions} onSuccess={fetchEpicenters} />}
                    </div>
                </LayersControl>
            </MapContainer>
            {
                selected !== undefined &&
                <Sidebar
                    entityUrl={selected}
                    onClose={() => setSelected()}
                    onActionSuccess={() => {
                        fetchDams(); fetchEpicenters()
                    }}
                />
            }

        </>
    )
}

export default Map;

function Epicenter({ epicenter, onSelect }) {
    const [showCircle, setShowCircle] = useState(false)
    const epicenterIcon = new icon({
        iconUrl: require('../resources/earthquake.png'),
        iconSize: [20, 20]
    })
    const selfLink = epicenter?.links?.find((link) => link.rel.includes('self'));

    var date = new Date(epicenter.properties.date);
    var formattedDate = date.toLocaleString('pt-PT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: 'UTC'
    });

    return epicenter !== undefined && (<>
        <Marker position={[epicenter.properties.latitude, epicenter.properties.longitude]}
            key={epicenter.properties.latitude}
            icon={epicenterIcon}
            eventHandlers={{
                click: () => {
                    setShowCircle(!showCircle)
                },
            }}>
            <Popup>
                <p>Title: {epicenter.properties.title}</p>
                <p>Date: {formattedDate}</p>
                <p>Magnitude: {epicenter.properties.magnitude}</p>
                <p>Latitude: {epicenter.properties.latitude}  ºN</p>
                <p>Longitude: {epicenter.properties.longitude} ºE</p>
                <Button variant="primary"
                    onClick={() => onSelect(selfLink.href)}>
                    Expand
                </Button>
            </Popup>

        </Marker>
        {showCircle && <Circle
            center={
                [epicenter.properties.latitude, epicenter.properties.longitude]
            }
            radius={epicenter.properties.radius}
        />}
    </>);
}

function DamCard({ dam, onExpand }) {
    const mainImg = dam?.links?.find((link) => link.class?.includes('main_image'))
    const selfLink = dam?.links?.find((link) => link.rel?.includes('self'))
    const damIcon = new icon({
        iconUrl: require('../resources/dam2.png'),
        iconSize: [20, 20]
    })
    return (
        <Marker position={dam.properties.location}
            key={dam.properties.name}
            icon={damIcon}
        >
            <Popup>
                <Card style={{ width: '18rem' }}>
                    {
                        mainImg && <Card.Img variant="top" src={mainImg.href} />
                    }
                    <Card.Body>
                        <Card.Title>{dam.properties.name}</Card.Title>
                        <Button variant="primary"
                            onClick={() => onExpand(selfLink.href)}>
                            Expand
                        </Button>
                    </Card.Body>
                </Card>
            </Popup>
            <Tooltip
                direction="bottom"
                offset={[0, 10]}
                opacity={1}
            >
                {dam.properties.name}
            </Tooltip>
        </Marker>
    )
}
